import { render, staticRenderFns } from "./club-details.vue?vue&type=template&id=b9d4d3b6&scoped=true"
import script from "./club-details.vue?vue&type=script&lang=js"
export * from "./club-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d4d3b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/subsapp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9d4d3b6')) {
      api.createRecord('b9d4d3b6', component.options)
    } else {
      api.reload('b9d4d3b6', component.options)
    }
    module.hot.accept("./club-details.vue?vue&type=template&id=b9d4d3b6&scoped=true", function () {
      api.rerender('b9d4d3b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/club-details/club-details.vue"
export default component.exports